<template>
  <div class="container-like">
    <div class="content-like">
      <div class="section-matrix-like"
        v-for="(item, idx) in question.subjects"
        :key="idx"
        :class="{
          'no-labels': question.imageOnTitle && question.imageOnTitle.length > idx && question.showImageOnTitle && question.hideAllSubjectLabels
        }">
        <div class="image-container" v-if="question.imageOnTitle && question.imageOnTitle.length > idx && question.showImageOnTitle">
          <image-viewer
            :image="question.imageOnTitle[idx]"
            position="left"
            :question-type="question.type"
            :show-image-on-title="question.showImageOnTitle"
          />
        </div>
        <div class="content-container">
          <div class="section-label" v-if="!question.showImageOnTitle || (!question.hideAllSubjectLabels && question.showImageOnTitle)">
            <span :style="colors.splashColor" v-html="replaceMeta(item.label)"></span>
          </div>
          <div class="section-rating">
            <div class="content-rating">
              <app-form-rate-active
                v-model="inputValue"
                :items="items"
                item-value="id"
                @rate-value="updateValue($event, item._id)"
              />
              <i class="material-icons up">thumb_up</i>
              <i class="material-icons down">thumb_down</i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { replaceMetadata } from '../../_helpers/metadata'
import ImageViewer from '@/components/common/ImageViewer.vue'

export default {
  name: 'like',
  props: ['question', 'colors'],
  components: {
    'app-form-rate-active': () => import('@binds-tech/binds-design-system/src/components/Form/RateActive'),
    ImageViewer
  },
  data () {
    return {
      inputValue: '',
      value: [],
      items: [
        { id: 1, value: 0 },
        { id: 2, value: 100 }
      ]
    }
  },
  mounted () {
    if (this.question.language) {
      this.$i18n.locale = this.question.language
    }
    this.$root.$on('footer-submit', payload => {
      if (payload) {
        this.submit()
      }
    })
  },
  methods: {
    updateValue (rating, id) {
      const optionIndex = this.value.findIndex(item => item._id === id)
      if (optionIndex > -1) {
        this.value[optionIndex].rating = rating
      } else {
        this.value.push({
          _id: id,
          rating
        })
      }
      if (this.question.required && (this.value.length === this.question.subjects.length)) {
        this.$root.$emit('show-btn', true)
      }
    },
    submit () {
      const send = this.value
      let submitSubjects = {}
      send.length > 0 ? submitSubjects = { value: send } : submitSubjects = { skip: true }
      this.$emit('value-changed', submitSubjects)
      this.$emit('question-answered', true)
      this.$root.$emit('refresh-footer')
    },
    replaceMeta (str) {
      return replaceMetadata(str, this.metadata, this.answersList)
    }
  },
  computed: {
    questionsList () {
      const qs = this.$store.getters['question/getQuestion']
      return qs
    },
    metadata () {
      let data
      if (!this.isPreview) {
        data = this.$store.getters['seedData/getSeedData']
      } else {
        data = this.$store.getters['preview/getSeedData']
      }

      const metadata = data && data.metadata ? data.metadata : {}
      return metadata
    }
  }
}
</script>

<style lang="scss">
.container-like {
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .content-like {
    width: 95%;
    min-height: 100%;
    margin: 10px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .section-matrix-like {
      border: 1px solid #e0e0e0;
      border-radius: 5px;
      padding: 4px;
      width: 100%;
      min-height: 50px;
      margin-bottom: 10px;
      display: flex;
      align-items: center;
      gap: 15px;
      justify-content: flex-start;

      &.no-labels {
        justify-content: center;

        .content-container {
          width: auto;
          flex: 0 1 auto;
        }
      }

      .image-container {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 5px;
        width: fit-content;

        .image-zoom-container {
          width: 100px;
          height: 100px;
        }
        .image-viewer-container {
          width: 100%;
          height: 100%;
          margin: 0;
        }
      }

      .content-container {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        min-height: 50px;
        gap: 15px;

        &:only-child {
          width: 100%;
        }

        &:not(:has(.section-label)) {
          justify-content: center;
          width: auto;
        }

        .section-label {
          width: 65%;
          min-height: 100%;
          padding-left: 5px;
          display: block;
          align-items: center;
          span {
            overflow-wrap: break-word;
            color: var(--splashColor);
          }
        }

        .section-rating {
          width: fit-content;
          height: 52px;
          display: flex;
          align-items: center;
          justify-content: space-around;

          .content-container:not(:has(.section-label)) & {
            width: auto;
          }

          .content-rating {
            position: relative;
            height: 80%;
            width: 70%;
            min-width: 150px;
            border-radius: 35px;
            box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.26);
            border: 1px solid #cacaca;
            overflow: hidden;
            display: flex;
            align-items: center;
            justify-content: center;
            .rating {
              z-index: 10;
              width: 100%;
              height: 100%;
              padding: 0;
              display: flex;
              align-items: center;
              justify-content: space-between;
              .rating__item:nth-child(2) {
                width: 50%;
                height: 100%;
                border-radius: 35px 0 0 35px;
                .rating__button {
                  width: 100%;
                  border-radius: 35px 0 0 35px;
                  height: 100%;
                  background: transparent !important;
                }
                .rating__button:hover {
                  background: #ea492240 !important;
                }
                .active-rate {
                  transform: scale(1) !important;
                  border: none !important;
                  background: #ea492240 !important;
                }
              }
              .rating__item:nth-child(5) {
                width: 50%;
                height: 100%;
                border-radius: 0 35px 35px 0;
                .rating__button {
                  border-radius: 0 35px 35px 0;
                  border-left: 1px solid #b6b6b6;
                  width: 100%;
                  height: 100%;
                  background: transparent !important;
                }
                .rating__button:hover {
                  background: #51ad5940 !important;
                }
                .active-rate {
                  transform: scale(1) !important;
                  border: none !important;
                  background: #51ad5940 !important;
                }
              }
            }
            .up {
              position: absolute;
              right: 25px;
              color: #51ad59;
            }
            .down {
              position: absolute;
              left: 25px;
              color: #ea4922;
            }
          }
        }
      }
    }
  }
}

// Responsivity for mobile
@media only screen and (max-width: 850px) {
  .container-like {
    .content-like {
      .section-matrix-like {
        flex-direction: column;
        gap: 10px;
        padding: 10px;

        .image-container {
          .image-zoom-container {
            width: 190px;
            height: 190px;
          }
        }

        .content-container {
          width: 100%;
          flex-direction: column;
          gap: 10px;

          .section-label {
            width: 100%;
            text-align: center;
            padding: 0;
          }

          .section-rating {
            width: fit-content;
          }

        }

        &.no-labels {
          .content-container {
            flex-direction: row;
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 480px) {
  .container-like {
    .content-like {
      .section-matrix-like {
        .image-container {
          .image-zoom-container {
            width: 190px;
            height: 190px;
          }
        }

        .content-container {
          .section-rating {
            width: fit-content;
            .content-rating {
              width: 180px;
            }
          }
        }

        &.no-labels {
          .content-container {
            .section-rating {
              .content-rating {
                width: 180px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
